import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PortalShell } from '../components/PortalShell';
import { SignInForms } from '../components/SignInForms';
import { MARKETING_URL } from '../marketing-url';

/**
 * Phase 14a-2 — sign-in accepts `?next=<encoded URL>` so the admin app
 * can bounce unauthenticated operators here then back to the admin
 * destination after TOTP completion. The `next` value is allowlisted
 * against `VITE_PORTAL_URL` + `VITE_ADMIN_URL` hosts inside
 * `SignInForms` via `lib/next-redirect.ts`; this route only declares
 * the search shape so TanStack Router parses it.
 */
const SearchSchema = z.object({
  next: z.string().optional(),
});

export const Route = createFileRoute('/sign-in')({
  validateSearch: (search) => SearchSchema.parse(search),
  component: SignInPage,
});

function SignInPage() {
  return (
    <PortalShell signedOutSurface>
      <div className="mx-auto max-w-5xl px-6 pt-12 md:pt-20 pb-16">
        <header className="mb-8 md:mb-12">
          <h1 className="font-heading text-3xl md:text-4xl text-forest">
            Sign in to TrueCare™ Partners
          </h1>
          <p className="mt-3 font-body text-base text-ink-muted">
            Use either method — both work. New to TrueCare™ Partners?{' '}
            <a
              href={MARKETING_URL}
              className="text-forest underline-offset-2 hover:text-gold hover:underline"
            >
              Apply or get in touch on our home page
            </a>
            .
          </p>
        </header>
        <SignInForms />
      </div>
    </PortalShell>
  );
}
